import mitt from "mitt";

const emitter = mitt();

export enum EVENTS {
  SET_LOGIN_DATA = "SET_LOGIN_DATA",
  START_PERFORMER_VERIFICATION = "START_PERFORMER_VERIFICATION",
  BALANCE_REFILL_SHOW = "BALANCE_REFILL_SHOW",
  BALANCE_REFILL_HIDE = "BALANCE_REFILL_HIDE",
  MESSAGES_NEW_MESSAGE = "MESSAGES_NEW_MESSAGE",
  MESSAGES_MARKED_READ = "MESSAGES_MARKED_READ",
  FOOTER_HIDE = "FOOTER_HIDE",
  FOOTER_SHOW = "FOOTER_SHOW",
  SET_BOOKING_USER = "SET_BOOKING_USER",
  APPOINTMENT_BANNER_HIDE = "APPOINTMENT_BANNER_HIDE",
  APPOINTMENT_BANNER_SHOW = "APPOINTMENT_BANNER_SHOW",
  USER_DID_NOT_INTERACT_DOC_FIRST = "USER_DID_NOT_INTERACT_DOC_FIRST",
  THREADS_REFRESH = "THREADS_REFRESH",
  /** Group Topics (Темы): fired after a topic is created / renamed / deleted /
   *  reordered so the TopicsList overview refreshes. */
  TOPICS_CHANGED = "TOPICS_CHANGED",
  MESSAGES_OPTIMISTIC_RESOLVE = "MESSAGES_OPTIMISTIC_RESOLVE",
  /** Fired when the user accepted a call via a native out-of-band UI
   *  (iOS CallKit banner, Android heads-up notification, Electron system
   *  overlay) instead of the in-page IncomingCallModal. Listeners should
   *  dismiss their own ringing UI for this callId — the acceptance has
   *  already been submitted to the backend. Payload: { callId: string }. */
  CALL_ANSWERED_EXTERNALLY = "CALL_ANSWERED_EXTERNALLY",
  /** Fired when a native out-of-band UI cancelled / dismissed an incoming
   *  call without the user accepting it (CallKit auto-end after timeout,
   *  remote cancel push, declined-from-banner). Listeners should dismiss
   *  their own ringing UI for this callId. Payload: { callId: string }. */
  CALL_CANCELLED_EXTERNALLY = "CALL_CANCELLED_EXTERNALLY",
  /** Fired by useShareTarget (native only) when the OS share sheet delivered
   *  files/text into the app. The globally-mounted ShareTargetModal opens a
   *  chat picker in response. Payload: { shareId: string; files: File[]; text?: string }. */
  SHARE_RECEIVED = "SHARE_RECEIVED",
  /** Fired by ShareTargetModal after it stashes shared content for a thread and
   *  navigates there. MessageInput consumes the stash on this signal so a share
   *  into the chat already on screen (a no-op navigation that doesn't change
   *  currentThreadId) is still picked up. Payload: { threadId: string }. */
  SHARE_HANDOFF = "SHARE_HANDOFF",
  /** Fired after a message is scheduled or a scheduled message is cancelled, so
   *  the ScheduledMessages panel for that thread reloads its list/count. This is
   *  the only user-visible confirmation of a scheduled send (scheduled rows are
   *  filtered out of the normal thread history). Payload: { threadId: string }. */
  SCHEDULED_MESSAGES_CHANGED = "SCHEDULED_MESSAGES_CHANGED",
}
export const SYSTEM_MESSAGE_PREFIX = "__SYSTEM__:";

export default emitter;
